(function initializeStackhouseUploaderErrorPopup(scope) {
  let previousFocus = null;

  function closeErrorPopup() {
    const popup = document.getElementById('error-popup');
    if (!popup) return;
    popup.style.display = 'none';
    previousFocus?.focus?.();
    previousFocus = null;
  }

  function createErrorPopup() {
    if (document.getElementById('error-popup')) return;

    const popup = document.createElement('div');
    popup.id = 'error-popup';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-labelledby', 'error-popup-title');
    popup.setAttribute('aria-describedby', 'error-message');
    popup.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;background:rgba(0,0,0,.5);z-index:9999;display:none;justify-content:center;align-items:center';

    const content = document.createElement('div');
    content.style.cssText = 'background:#fff;border-radius:8px;max-width:500px;width:90%;box-shadow:0 4px 8px rgba(0,0,0,.2);overflow:hidden';

    const header = document.createElement('div');
    header.style.cssText = 'background:#f44336;color:#fff;padding:15px 20px;display:flex;justify-content:space-between;align-items:center';

    const title = document.createElement('h3');
    title.id = 'error-popup-title';
    title.textContent = 'Error';
    title.style.cssText = 'margin:0;font-size:18px';

    const closeBtn = document.createElement('button');
    closeBtn.id = 'error-popup-close';
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Close error message');
    closeBtn.innerHTML = '&times;';
    closeBtn.style.cssText = 'background:none;border:0;color:#fff;font-size:24px;cursor:pointer;padding:0;line-height:1';
    closeBtn.onclick = closeErrorPopup;

    const body = document.createElement('div');
    body.style.cssText = 'padding:20px';

    const message = document.createElement('p');
    message.id = 'error-message';
    message.style.cssText = 'margin:0 0 15px;line-height:1.5';

    const supportLinkContainer = document.createElement('div');
    supportLinkContainer.id = 'error-support-link-container';
    supportLinkContainer.style.display = 'none';

    const supportLink = document.createElement('a');
    supportLink.id = 'error-support-link';
    supportLink.textContent = 'Get Help';
    supportLink.target = '_blank';
    supportLink.rel = 'noopener noreferrer';
    supportLink.style.cssText = 'display:inline-block;background:#4CAF50;color:#fff;padding:10px 15px;text-decoration:none;border-radius:4px;font-weight:500;margin-top:10px';

    header.appendChild(title);
    header.appendChild(closeBtn);
    supportLinkContainer.appendChild(supportLink);
    body.appendChild(message);
    body.appendChild(supportLinkContainer);
    content.appendChild(header);
    content.appendChild(body);
    popup.appendChild(content);

    popup.addEventListener('click', function handleBackdropClick(event) {
      if (event.target === popup) closeErrorPopup();
    });
    popup.addEventListener('keydown', function handleErrorKeydown(event) {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      closeErrorPopup();
    });
    document.body.appendChild(popup);
  }

  function showError(message, supportLink) {
    createErrorPopup();

    const errorPopup = document.getElementById('error-popup');
    const errorMessage = document.getElementById('error-message');
    const errorSupportLinkContainer = document.getElementById('error-support-link-container');
    const errorSupportLink = document.getElementById('error-support-link');
    const errorCloseButton = document.getElementById('error-popup-close');

    errorMessage.textContent = message;
    errorSupportLink.href = supportLink || 'https://help.thestackhouse.com/hc/en-us/categories/21709397505037-File-Prep-and-Color-Management';
    errorSupportLinkContainer.style.display = 'block';
    previousFocus = document.activeElement;
    errorPopup.style.display = 'flex';
    requestAnimationFrame(function focusErrorDialog() {
      errorCloseButton.focus();
    });
  }

  scope.StackhouseUploaderErrorPopup = {
    showError: showError
  };
})(window);
